//import React from "react";
import React, {useState,useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { UseDeleteApi } from "beaktShared/services/crudeApiService";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";

// services
import { SessionContext } from "beaktShared/services/session";
import Avaliacao from "./Avaliacao";
import { setAvaliacaoConsultaCookie } from "beaktClinic/services/avaliacaoCookie";
import { formateDateandTime } from "beaktShared/helpers/masks";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";
const useStyles = makeStyles(styles);

export default function AvaliacoesPendentes() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const endPoint = 'avaliacoes/';

    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});
    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [loadingForm, setLoadingForm] = React.useState(false);

    const [list, setlist, isErrorGetList] = React.useState([]);

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    useEffect(() => {
        loadAgendamentos();  
    }, []);
    
    const handleView = (resetItem) => {
        if (resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);
    };  

    const handleEdit = dados => {                                      
        let avaliacao = {
            'avaliacaoId': dados.avaliacaoId,
            'cliente' : 
            {
                'cpf' : dados.cliente.cpf,
                'nome' : dados.cliente.nome,
                'email' : dados.cliente.email,
                'celular' : dados.cliente.celular,
                'sexo' : dados.cliente.sexo,
                'atendente' : dados.cliente.cpf,
                'estabelecimentoClientes' : [{
                    'estabelecimentoId' : session.estabelecimentoId
                }]
            },
            'kg': dados.peso,
            'altura': dados.altura,
            'idade': dados.idade,
            'quadril': dados.quadril,
            'cintura': dados.cintura,
            'peso5anos': dados.peso5anos,
            'gordura': dados.percentualGordura,
            'sedentarismo': dados.nivel,
            'diametroPunho': dados.diametroPunho,  
            'diametroJoelho': dados.diametroJoelho,
            'realizaAcompanhamentoDiabete': dados.realizaAcompanhamentoDiabete,
        }                           

        setAvaliacaoConsultaCookie(avaliacao);
        setItem(dados);
        handleView(false);
    };

    const loadAgendamentos = () =>{        
        const endPoint = "avaliacoes/byestabelecimento/" + session.estabelecimentoId;
        setisLoadingList(true);
        UseGetApiSimple(endPoint,0).then(result=>{         
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setisLoadingList(false);
                return false; 
            }   
            setlist(result.data);
            setisLoadingList(false);
            return true;                
        });
    }  
    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id => {
        var userDeletadoId = session.id;

        UseDeleteApi(endPoint, id, userDeletadoId).then(result => {
            if (result.status !== 200) {
                setAlertDelete({ statusAlert: 2 });
                showNotification(result.message, 'danger');
                return false;
            }

            var listFiltered = list.filter(obj => {
                return obj.avaliacaoId !== id;
            });
            setlist(listFiltered);
            setAlertDelete({ statusAlert: 3 });
            return true;
        });
    };
    const showAlertDelete = id => {
        setAlertDelete({
            statusAlert: 1,
            idToDeleteRecieve: id
        });
    }
    useEffect(() => {
        if (alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);
        // eslint-disable-next-line     
    }, [alertDelete]);
    const columnsProp = [{
        Header: t('label.date'), 
        accessor: "dataCadastro",
        Cell : (row)=>{
            let custom_date = formateDateandTime(row.original.dataCadastro);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.client_name'),
        accessor: "cliente.nome"
    },
    {
        Header: t('label.cell_phone'),
        accessor: "cliente.celular"
    },
    {
        Header: t('label.cpf'),
        accessor: "cliente.cpf"
    },
    {
        Header: t('label.email'),
        accessor: "cliente.email"
    }]
    const columnsAcao = [
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">
                <Link to="/adminclinic/avaliacao" >
                    <Button color="transparent" 
                            onClick={() => handleEdit(row.original)}
                            style={{ border: '2px solid #562682', color: '#562682', padding: '0px 6px', height: '40px', textAlign:'center'}}>
                            <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Search />
                        </Tooltip>
                    </Button>
                </Link>
                <Button color="transparent" 
                        onClick={() => showAlertDelete(row.original.avaliacaoId)}
                        style={{ border: '2px solid red', color: 'red', padding: '0px 6px', height: '40px', textAlign:'center' }}>
                    <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                    <Close />
                    </Tooltip>
                </Button>
            </div>
        ),
        sortable: false,
        filterable: false
    }
    ];
    const columns = [...columnsProp, ...columnsAcao]

    const classes = useStyles();
    return (
        <div>
            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView && 
                            <Avaliacao item={item} handleView={handleView} loading={loadingForm} />} 
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('sidebar.pending_avaliation')}</h4>
                        </CardHeader>
                        <CardBody>

                            <Link to="/adminclinic/avaliacao" >
                                <Button color="primary" className={classes.newButton}>
                                    {t('sidebar.new_avaliation')}
                                </Button>
                            </Link>
                            {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                            <ReactTable
                                loading={isLoadingList}
                                data={list}
                                columns={columns}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            {alertDelete.componente}

        </div>
    );
}